import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThreadApiService {
  private readonly httpClient = inject(HttpClient);

  getQuestionaireThread(payload) {
    const tagKey = `questionnaire:#${payload.questionnaire_id}`;
    const params = new HttpParams().set('tag_keys', tagKey);
    return this.httpClient.get('/api/v1/threads/query', {
      params
    });
  }

  getMessages(threadId: string) {
    return this.httpClient.get(`/api/v1/threads/${threadId}/messages`);
  }

  createThread(payload) {
    return this.httpClient.post('/api/v1/threads', payload);
  }

  addComment(payload, threadId: string) {
    return this.httpClient.post(`/api/v1/threads/${threadId}/messages`, payload);
  }
}
